<template>
    <div>
        <v-app class="p-4">
            <div class="col-md-12 p-0 mt-5 pt-10 mx-auto" style="border: none!important;">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text class="float-left" small @click="getDataForTable(url)" v-bind="attrs"
                               v-on="on"><span class="material-icons">refresh</span></v-btn>
                    </template>
                    <span>به روز رسانی لیست لیست بایگانی</span>
                </v-tooltip>
                <template>
                    <v-row justify="center">
                        <v-dialog
                                v-if="historyModal"
                                v-model="historyModal"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>مشاهده تاریخچه</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="historyModal = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <list-history :estate="true" :id="related_id"></list-history>
                            </v-card>
                        </v-dialog>
                        <v-dialog
                                v-if="showMore"
                                v-model="showMore"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>اطلاعات بیشتر آگهی</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="showMore = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <more-information :information="related_id"></more-information>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <template>
                    <v-row justify="center">
                        <v-dialog
                                v-if="relatedModal"
                                v-model="relatedModal"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>ویرایش فایل</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="relatedModal = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <edit-archive v-if="relatedModal" :modal="()=>{this.relatedModal=false}"
                                              :editToken="related_id"></edit-archive>
                            </v-card>
                        </v-dialog>
                        <v-dialog
                                v-if="showMore"
                                v-model="showMore"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>اطلاعات بیشتر آگهی</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="showMore = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <more-information :archive="true" :information="related_id"></more-information>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <!--      end edit mode -->
                <v-card :loading="loading" class="p-3 pt-0 mt-5">


                    <terminal-table class="col-12" :currentPage="datas.current_page"
                                    :perPage="datas.per_page" v-if="isMobile" :getData="getDataForTable"
                                    :pageCount="datas.last_page"
                                    :options="tableProps" :datas="datas" :headers="columns"></terminal-table>

                    <data-table
                            v-else
                            :data="datas"
                            :columns="columns"
                            :debounce-delay="3000"
                            :pagination="paginate"
                            :orderBy="tableProps.column"
                            :orderDir="tableProps.dir"
                            :translate="translate"
                            :per-page="[10, 25, 50, 100, 500]"
                            @on-table-props-changed="reloadTable"
                            class="pt-5 mt-13 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                    ></data-table>
                </v-card>
            </div>
        </v-app>
    </div>
</template>

<script>
import {dataTableProps} from "@/main";
import {debounce} from "../../../../custom";
import button from "../../button";
import NewEstate from "./newEstate";
import MoreInformation from "./moreInformation";
import EditSimple from "./editEstate";
import AddHistory from "./addHistory";
import EditArchive from "./editArchives";
import {Axios2} from "../../../../main";
import ListHistory from "./history/listHistory";


export default {
    name: "customerList",
    components: {ListHistory, EditArchive, AddHistory, EditSimple, MoreInformation, NewEstate},
    data() {
        return {
            loading: false,
            adsModal: false,
            relatedModal: false,
            historyModal: false,
            showMore: false,
            related_id: null,
            datas: {},
            mine: [],
            myRes: [],
            officers: [{owner: 'فایل های شخصی', 'owner_id': undefined}],
            activeComponent: '',
            translate: dataTableProps.translate,
            tableProps: dataTableProps.tableProps,
            paginate: dataTableProps.pagination,
            url: `${url}/user/archived`,
            selectedNumber: [],
            translates: [],
            dataId: '',
            adsList: '',
            columns: [
                {
                    label: '<input type="checkbox" id="selectAll">',
                    isCheckBox:true,
                    transform: (val) => {
                        return `<input type="checkbox"  data-id="${val.data.phone}">`
                    },
                    orderable: false,
                },
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.datas.current_page - 1;
                        row = row * this.datas.per_page;
                        return row + val.row + 1;
                    },
                    orderable: true,
                },
                {
                    label: 'عنوان ',
                    name: 'title',
                    primary: true,
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'منتشر کننده ',
                    name: 'type',
                    transform(val) {
                        return {'personal': 'شخص', 'divar': 'دیوار'}[val.data.type]
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'شهر / محله',
                    name: 'city',
                    transform: (val) => {
                        return this.translator("city_" + val.data.city);
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'متراژ',
                    name: 'size',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'آگهی دهنده',
                    name: 'customer.name',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'کد فایل',
                    name: 'identifier',
                    transform(val) {
                        return `<span class="badge badge-info">${val.data.identifier || 'ندارد'}</span>`
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'مدیریت',
                    name: 'action',
                    component: button,
                    event: "actions",
                    meta: {
                        buttons: [
                            {
                                name: 'delete',
                                label: 'حذف از بایگانی',
                                icon: 'trash-alt',
                                class: 'btn-outline-danger',
                                action: this.actions,
                            },
                            {
                                name: 'edit',
                                label: 'ویرایش اطلاعات',
                                icon: 'edit',
                                class: 'btn-outline-warning',
                                action: this.actions,
                            },
                            {
                                name: 'history',
                                label: 'تاریخچه',
                                icon: 'history',
                                class: 'btn-outline-success',
                                action: this.actions,
                            },
                            {
                                name: 'redirect',
                                label: 'بازگردانی فایل',
                                icon: 'arrow-left',
                                class: 'btn-outline-primary',
                                action: this.actions,
                            },
                            {
                                name: 'show',
                                label: 'نمایش اطلاعات',
                                icon: 'eye',
                                class: 'btn-outline-info',
                                action: this.actions,
                            },
                        ]
                    }
                },
            ],
            updatedData: [],
            authResult: [],

        }
    },
    methods: {
        translator(name) {
            return this.translates[name];
        },
        getDataForTable(url = this.url, query = this.tableProps) {
            const vm = this;

            vm.datas = [];
            vm.loading = true;

            $.ajax({
                url: url,
                type: 'GET',
                fn: this.getDataForTable,
                data: Object.assign({}, query, {agent: this.officers_id != null && this.officers_id !== 'فایل های شخصی' ? this.officers_id : undefined}),
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: function (data) {
                    vm.datas = data.data;
                    vm.loading = false;
                }
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getDataForTable(this.url, tableProps);
            }, 700);
        },
        actions(data, type) {
            this[type + "Action"](data);
        },
        deleteAction(data) {
            this.$modal.yesNo('تایید حذف', 'آیا از حذف این فایل اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                    $.ajax({
                        url: `${url}/user/archived/${data.id}`,
                        method: 'DELETE',
                        msg: true,
                        fn: this.deleteAction,
                        headers: {
                            "ACCEPT": "application/json",
                            "Authorization": Token
                        },
                        success: (val) => {
                            this.reloadTable();
                        },
                    });
                }
            }));
        },
        editAction: function (data) {
            this.relatedModal = true;
            this.related_id = data.id
        },
        historyAction: function (data) {
            this.historyModal = true;
            this.related_id = data.id
        },
        redirectAction(data) {
            this.$modal.yesNo('تایید بازگردانی', 'آیا از بازگردانی این فایل اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                    Axios2.post(`user/archived/${data.id}/restore`).then(() => {
                        this.$modal.success('موفقیت آمیز!', 'فایل با موفقیت بازگردانی شد.');
                        this.reloadTable();
                    })
                }
            }))

        },
        showAction: function (data) {
            this.showMore = true;
            this.related_id = data.id
        },
        getLocalization() {
            if (localStorage.getItem('localization')) {
                this.translates = JSON.parse(localStorage.getItem('localization'));
                return;
            }
            $.ajax({
                url: `${url}/setting/localization`,
                type: 'GET',
                fn: this.getLocalization,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.translates = data.data
                    localStorage.setItem('localization', JSON.stringify(data.data));
                }
            })
        },
    },
    mounted() {
        this.getDataForTable(this.url);
        if (localStorage.getItem('localization')) {
            this.translates = JSON.parse(localStorage.getItem('localization'));
            return;
        } else {
            this.getLocalization();
        }
        $(document).on('click', '#selectAll', (element) => {
            if ($(element.target).is(':checked')) {
                $('input[type="checkbox"]').prop('checked', true);

                const selected = $('input[type="checkbox"]').map(function () {
                    return $(this).data('id')
                }).get();

                this.selectedNumber = selected;
            } else {
                $('input[type="checkbox"]').prop('checked', false)
                this.selectedNumber = []
            }
        });
    },
    computed: {
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getDataForTable(this.url);
                    return true
                case 'sm':
                    this.getDataForTable(this.url);
                    return true
                case 'md':
                    this.getDataForTable(this.url);
                    return false
                case 'lg':
                    this.getDataForTable(this.url);
                    return false
                case 'xl':
                    this.getDataForTable(this.url);
                    return false
            }
        },
    },


}
</script>

<style scoped>

</style>